import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import * as moment from 'moment';
import {
  IntegrationImport,
  IntegrationImportColumn,
  IntegrationImportParams,
  Order
} from "../../integration-imports.interface";
import {GetIntegrationImportsAction} from "../../integration-imports.actions";
import {getIntegrationImportsParamsSelector} from "../../integration-imports.reducer";
import {IState} from "../../../../shared/models/state";
import {MatTableDataSource} from "@angular/material/table";
import {Sort} from "@angular/material/sort/typings/sort";

@Component({
  selector: 'cc-integration-imports-table',
  templateUrl: './integration-imports-table.component.html',
  styleUrls: ['./integration-imports-table.component.scss']
})
export class IntegrationImportsTableComponent implements OnInit {
  params: IntegrationImportParams;
  displayedColumns: string[] = [
    'operation',
    'startDate',
    'finishDate',
    'status',
    'contactsCreated',
    'contactsUpdated',
    'contactsRejected',
    'integrationType',
  ];
  sort: string;
  @Input() dataSource: MatTableDataSource<IntegrationImport>;
  @Output() rejectedClicked = new EventEmitter<number>();

  constructor(private store: Store<IState>) {
  }

  ngOnInit() {
    this.store.select(getIntegrationImportsParamsSelector).subscribe(params => {
      this.params = params;
    });
  }

  sortChange($event: Sort) {
    this.store.dispatch(new GetIntegrationImportsAction({
      ...this.params,
      order: $event.direction ? Order[$event.direction.toUpperCase()] : null,
      sortBy: IntegrationImportColumn[$event.active]
    }));
  }

  formatDate(date: string) {
    if (date) {
      return moment(date).format('LT, l');
    }
    return '';
  }
}
